import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ColorPickerComponent } from './components/color-picker/color-picker.component';

@NgModule({
  declarations: [ColorPickerComponent],
  imports: [CommonModule, TranslateModule, FormsModule],
  exports: [ColorPickerComponent],
})
export class ColorPickerModule {}
